import React, { useEffect, useState } from "react";
import styles from "./AdProviderConfiguration.module.css";
import { FaPlay, FaTv, FaMobileAlt, FaDesktop } from "react-icons/fa";
import { getAdManagement, postAdManagement } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";

const AdPositions = () => {
  const [adsConfig, setAdsConfig] = useState({});
  const [ads, setAds] = useState();


  const getAds = async () => {
    try {
      const response = await getAdManagement();
      setAdsConfig(response.data);
      setAds(response?.data);
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    getAds();
  }, []);

  const toggleAd = async (key) => {
    const updatedValue = !adsConfig[key];
    const updatedConfig = {
      ...adsConfig,
      [key]: updatedValue,
    };



    setAdsConfig(updatedConfig);
    

    try {
      await postAdManagement(ads?.id, updatedConfig); 
       showToast("Ad configuration updated successfully", "success");
      await getAds();
    } catch (error) {
      showToast(error.response?.data || error.message, "error");
      console.error(
        "Failed to update:",
        error.response?.data || error.message
      );
      setAdsConfig((prev) => ({
        ...prev,
        [key]: !updatedValue,
      }));
    }
  };

  return (
    <div className={styles.innerContainer}>
      {/* Ad Cards */}
      <div className={styles.adCards}>
        {/* Pre-Roll */}
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.iconContainer}>
              <FaPlay className={styles.icon} />
              <div>
                <h4>Pre-Roll Ads</h4>
                {/* <p>Before content</p> */}
              </div>
            </div>
            <div>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  checked={adsConfig.pre_roll}
                  onChange={() => toggleAd("pre_roll")}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
          </div>
          {/* <p>
            Max Duration: <span>30s</span>
          </p>
          <p>
            Skippable: <span>After 5s</span>
          </p> */}
        </div>

        {/* Mid-Roll */}
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.iconContainer}>
              <FaPlay className={styles.icon} />
              <div>
                <h4>Mid-Roll Ads</h4>
                {/* <p>During content</p> */}
              </div>
            </div>
            <div>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  checked={adsConfig.mid_roll}
                  onChange={() => toggleAd("mid_roll")}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
          </div>
          {/* <p>
            Frequency: <span>Every 15min</span>
          </p>
          <p>
            Max Duration: <span>15s</span>
          </p> */}
        </div>

        {/* Post-Roll */}
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.iconContainer}>
              <FaTv className={styles.icon} />
              <div>
                <h4>Post-Roll Ads</h4>
                {/* <p>After content</p> */}
              </div>
            </div>
            <div>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  checked={adsConfig.post_roll}
                  onChange={() => toggleAd("post_roll")}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
          </div>
          {/* <p>
            Max Duration: <span>30s</span>
          </p>
          <p>
            Auto-play Next: <span>Enabled</span>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default AdPositions;
